export const RESOURCE_EDGES = {
  // ResourceEdges elements
  RESOURCE_PILL: 'resource-edges-resource-pill',
  MORE_RESOURCES_PILL: 'resource-edges-more-resources-pill'
} as const;
